import { graphHooks } from '@tunasong/graph-lib/react'
import { EntityList, useNavigateToEntity, type SidebarComponent } from '@tunasong/ui-lib'
import type { FC } from 'react'

export const SidebarContent: FC<SidebarComponent> = ({ entity }) => {
  const { entities } = graphHooks.useEntityChildren({ parentId: entity?.id, includeSys: true })

  const navigateToEntity = useNavigateToEntity()

  return <EntityList entities={entities} onOpen={navigateToEntity} />
}
